import TypeString from '../valueObject/TypeString';
import LoanSearchGateway from './LoanSearchGateway';

export default class LoanSearchService {
    static searchByKeyword(keywords: TypeString) {
        return new LoanSearchGateway().searchByKeyword(keywords);
    }
}
